import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/base.css"
import "./assets/css/component.css"
import encryption from './untils/encryption.js'

//滑块验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
Vue.config.productionTip = false

//引入request
import request from "./untils/request"
//将request挂载在vue的原型上  在所有组件都能用
Vue.prototype.request = request

//引入local文件 获取浏览器本地数据库
import local from "./untils/local"
Vue.prototype.local = local

//引入MD5加密工具
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import { Toast } from 'vant';
Vue.prototype.$toast = Toast;

//复制
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)


Vue.prototype.Encryp = encryption;



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
